import { useEffect } from "react";

import { storeCTEvent }                 from "_analytics/index";
import { useSetLoginPopup }             from "_common/hooks/global";
import { initialValidations }           from "_common/ssrWrapper";
import { createURLSearchParams }        from "_common/webview";
import { getParamValueFromQueryString } from "_common/webview";
import ErrorPage                        from "_components/features/creatorDashboard/atoms/dashboardErrorPage";
import Overview                         from "_components/features/creatorDashboard/pages/overview";
import { getMigrateData }               from "_services/api/creator-dashboard";

const component = props => {

	const setLoginPopup = useSetLoginPopup ();

	useEffect ( () => {
		// if logged in do nothing
		if ( props?.userId )
			return;

		setLoginPopup ( true );

		const ctOptions = {
			eventProperty : "from",
			value         : getParamValueFromQueryString ( "from" )
		};

		storeCTEvent ( "creator_dashboard_clicked", ctOptions );

	}, [ props?.userId ] );

	if ( props?.error || !props?.userId ) {
		const errorMsg = !props?.userId ? "Please Login" : props?.error?.displayMsg;

		return <ErrorPage customMsg = { errorMsg } />;
	}

	return (
		<Overview
			intialMonetisationData = { props?.intialMonetisationData }
			isMigratingData        = { true }
			isMobile               = { props?.isMobile }
			latestContent          = { props?.latestContent }
		/>
	);
};

const getServerSideProps = async context => initialValidations ( context, async defaultProps => {

	try { // check for redirection to home page if the used is not logged in
		if ( !defaultProps?.userAuth?.userId && !context.query.userId ) {
			return {
				props: {
					...defaultProps,
					userId: null
				}
			};
		}

		let latestContent          = [];
		let intialMonetisationData = {};
		let migratedDataStatus     = "";
		let errorMigratedData      = null;
		let forceLogout            = false;

		const results = await Promise.allSettled (
			[
				getMigrateData.bind ( defaultProps ) ( defaultProps?.userAuth?.userId )
			]
		);

		results.forEach ( ( result, index ) => {
			if ( result.status === "fulfilled" ) {
				switch ( index ) {
					case 0:
						migratedDataStatus = result.value;
						break;

				}
			}

			if ( index === 0 && result.status === "rejected" && result.reason?.message !== "TOKEN_EXPIRED" ) {
				errorMigratedData = result.reason;
			}

			if ( result.status === "rejected" && result.reason?.message === "TOKEN_EXPIRED_FORCE_LOGOUT" )
				forceLogout = true;
		} );

		if ( forceLogout )
			return {
				redirect: {
					destination : `/logout?forceLogout=${ true }`,
					permanent   : false
				}
			};

		const params = createURLSearchParams ( context.query ); // handling webview URL

		if ( migratedDataStatus === "DATA ALREADY PRESENT" ) {
			return {
				redirect: {
					destination : `/creator-dashboard/overview${ params }`,
					permanent   : false
				}
			};
		}

		/* context.res.setHeader (
      "Cache-Control",
      "public, s-maxage=10, stale-while-revalidate=30"
    ); */

		return {
			props: {
				...defaultProps,
				userId   : defaultProps?.userAuth?.userId || context.query.userId,
				latestContent,
				intialMonetisationData,
				error    : errorMigratedData,
				isMobile : defaultProps?.isMobile
			}
		};
	} catch ( e ) {
		return {
			props: {
				...defaultProps,
				userId                 : defaultProps?.userAuth?.userId || context.query.userId,
				latestContent          : [],
				intialMonetisationData : {},
				error                  : e,
				isMobile               : defaultProps?.isMobile
			}
		};
	}
} );

export { getServerSideProps };

export default component;
